import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import * as Lookups from "../../infrastructure/lookup-list"

import { FetchWrapper } from "../../infrastructure/fetch-wrapper";

@Component
export default class NavMenu extends Vue {


    @Prop({default:[]})
    lookups: Lookups.ILookupDef[];

    @Prop()
    showLookups: boolean;

    @Prop()
    navUlClass: string;

    @Prop()
    showHeader: boolean;

    @Prop()
    showUserAccounts: boolean;

    @Prop()
    showCustomers: boolean;

    @Prop()
    showHistory: boolean;

    @Prop({default: false})
    isMounted: boolean;

    //private policyServices: IUserPolicyServices;


    mounted() {

        this.lookups = Lookups.LookupDefs.lookupDefs; 

        //FetchWrapper.fetch("/api/userauth/accessibleareas")
        //    .then(response => response.json())
        //    .then((response: IAreaAccessInfo[]) => {
        //        this.policyServices = new UserPolicyServices(response);

        //    })
        //    .then(() => this.isMounted = true);
        this.isMounted = true;
    }

    created() {
        //if (!this.lookups)
        //this.lookups = ;



    }

    canAccess(areaName: string): boolean {
        return true; //this.policyServices.canAccess(areaName);
    }

}


// WEBPACK FOOTER //
// ./ClientApp/components/nav-menu/nav-menu.ts